import * as trackActionTypes from '../../constants/actionTypes/tracks'
import { trackStatus } from '@bt-react/constants'
import getTracksByStatus from '../../../lib/getTracksByStatus'
import getTwilioTracks from '../../../lib/getTwilioTracks'
import isScreenshareTrack from '../../../lib/isScreenshareTrack'
import publishScreenTrack from '../../../lib/publishScreenTrack'
import { State, ReduxAction } from '../../reducers/reducerType'
import { TrackType } from './trackTypes'
import { Room } from 'twilio-video'
import username from '../../../lib/username'
import { debug } from '@bt-react/libs/Logger'
import get from 'lodash/get'
import notifications from '../../../dataStore/actions/notifications'
import roomActions from '../room'
import selectIsForcedMuted from '../../selectors/selectIsForcedMuted'
import uniq from 'lodash/uniq'
import isEqual from 'lodash/isEqual'
import { TwilioUIDocInterface } from '../../reducers/docs/types'
import { PlayInStatus } from '../../../lib/playIn/types'
import { UPDATE_UI_DOC_SUCCESS, UPDATE_UI_DOC_ERROR } from '../../constants/actionTypes'
import storage from '../../../lib/storage'
import amendVideoQuality from '../../../lib/amendVideoQuality'
import selectDialInParticipants from '../../selectors/selectDialInParticipants'
import { AudioSource } from '../../reducers/tracks/tracksReducerDefaultState'
import getBTIDsByRole from '../../../lib/getBTIDsByRole'
import { addNotification } from '../notifications/notifications'
import selectPresenterMuted from '../../selectors/selectPresenterMuted'
import { addEntry } from '../../../lib/audit'
import { PresenterBackground, VirtualBackgrounds } from '../../../components/VirtualBackgroundPicker/VirtualBackgroundPicker'
import selectPresenterBackground from '../../selectors/selectPresenterBackground'
import changeTwilioTrackState from '../../../lib/changeTwilioTrackState'
import selectIsLocalParticipantDialedIn from '../../selectors/selectIsLocalParticipantDialedIn'
import { TrackState } from '../../../lib/changeTwilioTrackState/types'
import { startNetworkTest, startBandwidthTest } from '@bt-react/libs'
import { CONTROLLER } from '../../constants/roles'
import getPresentersFromSeatingOrder from '../../selectors/getPresentersFromSeatingOrder'
import docUpdateAndLog from '../../../lib/docUpdateAndLog'
import { mediaType as MediaType } from '@bt-react/constants'


export const setTrackStatus = (presenterSid, trackSid, status) => (dispatch, getState) => {

  const tracks = getTwilioTracks(getState().room.room, presenterSid) || new Map()

  if (!tracks) return

  let kind = ''

  for (const [currTrackSid, value] of tracks) {

    if (trackSid === currTrackSid) kind = value.kind

  }

  if (kind === '') return

  dispatch({ type: trackActionTypes.SET_TRACK_STATUS,
    payload: {
      presenterSid,
      trackSid,
      kind,
      status
    }
  })
}

export const unattachedTrack = (presenterSid, trackSid) => async (dispatch, getState) => {

  const { room: { presenters } } = getState()
  const presenter = presenters.get(presenterSid)
  let restageTrack

  if (presenter) {

    const unstagedTracks = getTracksByStatus(presenter.tracks, trackStatus.UNSTAGED)

    if (unstagedTracks.length > 0) {

      restageTrack = unstagedTracks[0]

    }

  }

  dispatch({ type: trackActionTypes.TRACK_UNATTACHED, payload: { presenterSid, trackSid } })
  if (restageTrack) dispatch(setTrackStatus(presenterSid, restageTrack, trackStatus.STAGED))

}

export const publishScreen = () => async (dispatch, getState) => {

  const { room: { room: { localParticipant } }, config: { username }, syncUi: { autoSpotlight } } = getState()
  let success = false

  try {

    success = await publishScreenTrack(localParticipant, username)
    if (autoSpotlight) roomActions.setAutoSpotlight(false)

  }
  catch (e) {}

  if (success) dispatch({ type: trackActionTypes.PUBLISH_SCREEN_SUCCESS })
  else dispatch({ type: trackActionTypes.PUBLISH_SCREEN_ERROR })

}

export const unpublishScreen = () => async (dispatch, getState: () => State) => {

  const { room } = getState().room
  if (!room) return

  const { localParticipant } = room

  let newTrack

  for (const track of localParticipant.videoTracks) {

    const [trackSid, values] = track
    const isScreenShared = isScreenshareTrack(values)

    newTrack = !isScreenShared ? trackSid : newTrack

    if (isScreenShared) {

      values.track.mediaStreamTrack.stop()
      localParticipant.unpublishTrack(values.track)

    }

  }

  dispatch(setTrackStatus(localParticipant.sid, newTrack, trackStatus.STAGED))

}
export const setScreenshare = presenterSid => async (dispatch, getState) => {

  const { room: { mediaType } } = getState()

  if (mediaType === MediaType.SCREENSHARE) unpublishScreen()

  dispatch({ type: TrackType.SET_SCREENSHARE, payload: presenterSid })

}
export const unsetScreenshare = () => ({ type: TrackType.UNSET_SCREENSHARE })
export const localTracksAdded = () => ({ type: trackActionTypes.LOCAL_TRACKS_ADDED })
export const localTracksFailed = () => (dispatch) => {

  dispatch(roomActions.updatePermissions())
  return { type: trackActionTypes.LOCAL_TRACKS_FAILED }

}

export const removeVideoTracks = (room: Room | null = null) => {

  if (!room) return

  for (const [ , videoTrack ] of room.localParticipant.videoTracks) {

    if (!isScreenshareTrack(videoTrack)) {

      videoTrack.track.stop()
      videoTrack.unpublish()

    }

  }

}

export const removeScreenshareTrack = () => (dispatch, getState: () => State) => {

  const { room } = getState().room

  if (!room) return

  for (const [ , videoTrack ] of room.localParticipant.videoTracks) {

    if (isScreenshareTrack(videoTrack)) {

      videoTrack.track.stop()
      videoTrack.unpublish()

    }

  }

}
export const removeAudioTrack = (room: Room | null = null): boolean => {

  if (!room) return false

  for (const [ , audioTrackPublication ] of room.localParticipant.audioTracks.entries()) {

    audioTrackPublication.track.stop()
    audioTrackPublication.track.detach()
    audioTrackPublication.unpublish()

  }

  return true

}
export const removeLocalAudioTrack = () => ({ type: TrackType.REMOVE_LOCAL_AUDIO_TRACK_FOR_DIAL_IN })
export const removeLocalAudioTrackError = () => ({ type: TrackType.REMOVE_LOCAL_AUDIO_TRACK_FOR_DIAL_IN_ERROR })
export const removeLocalAudioTrackSuccess = () => ({ type: TrackType.REMOVE_LOCAL_AUDIO_TRACK_FOR_DIAL_IN_SUCCESS })
export const removeLocalAudioTrackDueToDialIn = (room: Room | null) => dispatch => {

  dispatch(removeLocalAudioTrack())

  if (!room) dispatch(removeLocalAudioTrackError())

  try {

    removeAudioTrack(room)
    dispatch(removeLocalAudioTrackSuccess())

  }
  catch (e) {

    dispatch(removeLocalAudioTrackError())

  }

}
export const createLocalVideoTrack = (deviceId?: string, background?: PresenterBackground): ReduxAction => typeof deviceId !== 'undefined'
  ? { type: TrackType.CREATE_LOCAL_VIDEO_TRACK, payload: { deviceId, background } }
  : { type: TrackType.CREATE_LOCAL_VIDEO_TRACK }
export const createLocalVideoTrackError = (er): ReduxAction => ({ type: TrackType.CREATE_LOCAL_VIDEO_TRACK_ERROR, payload: er.message })
export const createLocalVideoTrackSuccess = (): ReduxAction => ({ type: TrackType.CREATE_LOCAL_VIDEO_TRACK_SUCCESS })
export const createLocalAudioTrack = (deviceId?: string): ReduxAction => typeof deviceId !== 'undefined'
  ? { type: TrackType.CREATE_LOCAL_AUDIO_TRACK, payload: deviceId }
  : { type: TrackType.CREATE_LOCAL_AUDIO_TRACK }
export const createLocalAudioTrackError = (er): ReduxAction => {

  debug(get(er, 'message', er))
  return ({ type: TrackType.CREATE_LOCAL_AUDIO_TRACK_ERROR })

}
export const createLocalAudioTrackSuccess = (): ReduxAction => ({ type: TrackType.CREATE_LOCAL_AUDIO_TRACK_SUCCESS })
export const setSelectedVideoDevice = (selectedDevice: string, background: PresenterBackground): ReduxAction => {

  storage.setItem('alreadySelectedVideoDevice', selectedDevice);
  return { type: TrackType.SET_SELECTED_VIDEO_DEVICE, payload: { selectedDevice, background } }

}
export const setSelectedAudioDevice = (selectedDevice: string): ReduxAction<string> => {

  storage.setItem('alreadySelectedAudioDevice', selectedDevice);
  return { type: TrackType.SET_SELECTED_AUDIO_DEVICE, payload: selectedDevice }

}
export const setEnabledAudioTrackEntry = (trackId: string): ReduxAction<string> => ({ type: TrackType.SET_ENABLED_AUDIO_TRACK, payload: trackId })
export const removeEnabledAudioTrackEntry = (trackId: string): ReduxAction<string> => ({ type: TrackType.REMOVE_ENABLED_AUDIO_TRACK, payload: trackId })
export const setEnabledVideoTrackEntry = (trackId: string): ReduxAction<string> => ({ type: TrackType.SET_ENABLED_VIDEO_TRACK, payload: trackId })
export const removeEnabledVideoTrackEntry = (trackId: string): ReduxAction<string> => ({ type: TrackType.REMOVE_ENABLED_VIDEO_TRACK, payload: trackId })
export const verifyEnabledAudioTracks = (room: Room): ReduxAction => {

  if (!room) return { type: TrackType.SET_ENABLED_AUDIO_TRACKS_ERROR }

  const enabledTracks: string[] = []

  for (const [ , publication ] of room.localParticipant.audioTracks) {

    if (publication.track.isEnabled && publication.track.isStarted) {

      enabledTracks.push(publication.trackSid)
    }

  }

  // @ts-ignore
  const participantPresenters = Array.from(room.participants).filter(([ participantSid, participant ]) => {

    const id = participant.identity
    return username.isPresenter(id) || username.isDialIn(id)
  })

  // @ts-ignore
  for (const [ , participant ] of participantPresenters) {

    for (const [ , publication ] of participant.audioTracks) {

      if (!publication.track) continue

      if (!publication.isSubscribed) debug(`You are not subscribed to audio track ${publication.trackSid}`)

      if (publication.track.isEnabled && publication.track.isStarted) {

        enabledTracks.push(publication.trackSid)

      }

    }

  }

  debug(`Enabled audio tracks are ${enabledTracks}`)

  return { type: TrackType.SET_ENABLED_AUDIO_TRACKS, payload: enabledTracks }

}
export const verifyEnabledVideoTracks = (room: Room): ReduxAction => {

  if (!room) return { type: TrackType.SET_ENABLED_VIDEO_TRACKS_ERROR }

  const enabledTracks: string[] = []

  for (const [ , publication ] of room.localParticipant.videoTracks) {

    if (publication.track.isEnabled && publication.track.isStarted) {

      enabledTracks.push(publication.trackSid)

    }

  }

  // @ts-ignore
  const participantPresenters = Array.from(room.participants).filter(([ participantSid, participant ]) => {

    return username.isPresenter(participant.identity)

  })

  // @ts-ignore
  for (const [ , participant ] of participantPresenters) {

    for (const [ , publication ] of participant.videoTracks) {

      if (!publication.track) continue

      if (!publication.isSubscribed) debug(`You are not subscribed to video track ${publication.trackSid}`)

      if (publication.track.isEnabled && publication.track.isStarted) {

        enabledTracks.push(publication.trackSid)

      }

    }

  }

  debug(`Enabled video tracks are ${enabledTracks}`)

  return { type: TrackType.SET_ENABLED_VIDEO_TRACKS, payload: enabledTracks }

}
export const setInitialPresenterControlState = async (BTID: string, uiDoc: TwilioUIDocInterface): Promise<void> => {

  if (!uiDoc) return

  const isHidden: boolean = storage.getItem('talks-isHidden') || false
  const isMuted: boolean = storage.getItem('talks-isMuted') || false

  const { mute = [], videoDisplay = [] } = uiDoc.data
  let newMute: string[] = []
  let newVideoDisplay: string[] = []

  if (isMuted) newMute = uniq([ ...mute, BTID ])
  else newMute = mute.filter(_BTID => _BTID && _BTID !== BTID)

  if (isHidden) newVideoDisplay = uniq([ ...videoDisplay, BTID ])
  else newVideoDisplay = videoDisplay.filter(_BTID => _BTID && _BTID !== BTID)

  if (isEqual(mute, newMute) && isEqual(videoDisplay, newVideoDisplay)) return

  await docUpdateAndLog(uiDoc, { mute: newMute, videoDisplay: newVideoDisplay }, 'uiDoc')

}

export const updateAudioMute = (mutedIDs: string[]) => async (dispatch, getState: () => State) => {

  const {
    room: { room, participantLookup },
    syncUi: { mute },
    user: { BTID }
  } = getState()

  if (!room || !get(room, 'localParticipant')) {

    addEntry('PresenterService', 'UpdateAudioMute', `Call to updateAudioMute failed as no Room was defined`)
    return null

  }

  const isForcedMuted = selectIsForcedMuted(getState())

  if (isForcedMuted) return null

  if (mutedIDs.includes(BTID || '')) {

    for (const [, tracks] of room.localParticipant.audioTracks) {

      if (tracks.track.isEnabled) {

        tracks.track.disable()

      }

    }

  }
  else {

    for (const [, tracks] of room.localParticipant.audioTracks) {

      if (!tracks.track.isEnabled) {

        tracks.track.enable()

      }

    }

  }

  for (const remoteParticipantBTID of getBTIDsByRole(participantLookup, 'PRESENTER', 'DIAL_IN')) {

    if (remoteParticipantBTID !== BTID) {

      if (mutedIDs.includes(remoteParticipantBTID)) {

        dispatch(roomActions.participantMuted(remoteParticipantBTID))

      }
      else {

        if (mute.includes(remoteParticipantBTID)) dispatch(roomActions.participantUnmuted(remoteParticipantBTID))

      }

    }

  }

}

export const sendDialInMuteNotification = (muted?: boolean) => (dispatch, getState: () => State) => {

  if (typeof muted !== 'boolean') {

    const getIsPresenterMuted = selectPresenterMuted()
    muted = getIsPresenterMuted(getState(), {})

  }

  return muted
    ? dispatch(addNotification(`Mute your telephone device so other dialed-in presenters can't hear you`, 4000, 'dialInMuteNotification'))
    : dispatch(addNotification(`Unmute your telephone device to be heard by everyone`, 4000, 'dialInUnmuteNotification'))

}

export const toggleAudio = (updateBTID: string) => async (dispatch, getState: () => State) => {

  const mutedKey = 'talks-isMuted'

  const { docs: { uiDoc }, syncUi: { mute, playInMute }, user: { BTID }, playIn: { status } } = getState()

  if (!uiDoc) return dispatch({ type: TrackType.TOGGLE_AUDIO_TRACK_ERROR })

  const localParticipant: boolean = BTID === updateBTID
  const isMuted: boolean = storage.getItem(mutedKey) || false
  const isInMuteArray: boolean = mute.includes(updateBTID)

  const curValue: boolean = localParticipant && storage.hasPermission && status !== PlayInStatus.PLAYING
    ? isMuted
    : isInMuteArray
  const newValue = !curValue
  let newMute: string[] = []
  let newPlayInMute: string[] = []
  let auditMessage:string

  if (localParticipant && storage.hasPermission) {

    storage.setItem(mutedKey, newValue)
    if (storage.getItem(mutedKey) !== newValue) {

      return dispatch({ type: TrackType.TOGGLE_AUDIO_TRACK_ERROR })

    }

  }

  newMute = newValue ? uniq([ ...mute, updateBTID ]) : mute.filter(_BTID => _BTID && _BTID !== updateBTID)

  if (status === PlayInStatus.PLAYING) {

    newPlayInMute = newValue ? uniq([ ...playInMute, updateBTID ]) : playInMute.filter(_BTID => _BTID && _BTID !== updateBTID)

  }

// message to be logged into the audit trail when muting and unmuting in the presenter screen
  if(localParticipant){
      auditMessage=newValue?`${updateBTID}- presenter muted by self`:`${updateBTID}- presenter unmuted by self`
  }else{
      auditMessage=newValue?`${updateBTID}- presenter muted by - ${BTID}`:`${updateBTID}- presenter unmuted by - ${BTID}`
  }

  try {
    addEntry('PresenterService',newValue?'PresenterMuted': 'PresenterUnMuted',auditMessage, 'info')
    if (status === PlayInStatus.PLAYING) {
      await docUpdateAndLog(uiDoc, { mute: newMute, playInMute: newPlayInMute }, 'uiDoc')
    } else {
      await docUpdateAndLog(uiDoc, { mute: newMute }, 'uiDoc')
    }
    dispatch({ type: TrackType.TOGGLE_AUDIO_TRACK_SUCCESS })
    dispatch({ type: UPDATE_UI_DOC_SUCCESS })
  }
  catch (e) {

    if (localParticipant && storage.hasPermission) storage.setItem(mutedKey, curValue)
    dispatch({ type: TrackType.TOGGLE_AUDIO_TRACK_ERROR })
    dispatch({ type: UPDATE_UI_DOC_ERROR, payload: e })

  }

}

export const disableAudioOnPlayInStart = (mutedIDs: string[]) => async (dispatch, getState: () => State) => {

  const { docs: { uiDoc }, syncUi: { mute }, user: { BTID } } = getState()

  if (!uiDoc) return

  try {

    await docUpdateAndLog(uiDoc, { playInMute: mute, mute: mutedIDs }, 'uiDoc')
    dispatch({ type: TrackType.TOGGLE_AUDIO_TRACK_SUCCESS })
    dispatch({ type: UPDATE_UI_DOC_SUCCESS })

    if (BTID && !mute.includes(BTID)) dispatch(notifications.addNotification('Presenters mics are muted during video playback. You can unmute at any time.', 4000))

  }
  catch(e) {

    dispatch({ type: TrackType.TOGGLE_AUDIO_TRACK_ERROR })
    dispatch({ type: UPDATE_UI_DOC_ERROR, payload: e })

  }

}

export const enableAudioOnPlayInStop = (mutedIDs: string[]) => async (dispatch, getState: () => State) => {

  const { docs: { uiDoc }, room: { room }, user: { BTID }, syncUi: { mute } } = getState()

  if (!uiDoc) return

  const mutedKey = 'talks-isMuted'
  const isLocal = get(room, 'localParticipant') && storage.hasPermission
  const isMuted = storage.getItem(mutedKey)

  try {

    await docUpdateAndLog(uiDoc, { mute: mutedIDs }, 'uiDoc')

    if (isLocal && isMuted) storage.setItem(mutedKey, true)
    else if (isLocal && !isMuted) storage.setItem(mutedKey, false)

    if (BTID && !mutedIDs.includes(BTID) && mute.includes(BTID)) dispatch(notifications.addNotification('Presenters mics are unmuted', 4000))

    dispatch({ type: TrackType.TOGGLE_AUDIO_TRACK_SUCCESS })
    dispatch({ type: UPDATE_UI_DOC_SUCCESS })

  }
  catch(e) {

    dispatch({ type: TrackType.TOGGLE_AUDIO_TRACK_ERROR })
    dispatch({ type: UPDATE_UI_DOC_ERROR, payload: e })

  }

}

export const toggleVideo = (updateBTID: string) => async (dispatch, getState) => {

  const hiddenKey = 'talks-isHidden'

  const { docs: { uiDoc }, syncUi: { videoDisplay }, user: { BTID } } = getState()

  if (!uiDoc) return dispatch({ type: TrackType.TOGGLE_VIDEO_TRACK_ERROR })

  const localParticipant: boolean = BTID === updateBTID
  const isHidden: boolean = storage.getItem(hiddenKey) || false
  const isInHiddenArray: boolean = videoDisplay.includes(updateBTID)
  const curValue: boolean = localParticipant && storage.hasPermission
    ? isHidden
    : isInHiddenArray
  const newValue = !curValue
  let newVideoDisplay: string[] = []
  let auditMessage:string

  if(localParticipant){
    auditMessage=newValue?`${updateBTID}- presenter hidden by self`:`${updateBTID}- presenter unhidden by self`
  }else{
      auditMessage=newValue?`${updateBTID}- presenter hidden by - ${BTID}`:`${updateBTID}- presenter unhidden by - ${BTID}`
  }


  if (localParticipant && storage.hasPermission) {

    storage.setItem(hiddenKey, newValue)
    if (storage.getItem(hiddenKey) !== newValue) {

      return dispatch({ type: TrackType.TOGGLE_VIDEO_TRACK_ERROR })

    }

  }

  if (newValue) newVideoDisplay = uniq([ ...videoDisplay, updateBTID ])
  else newVideoDisplay = videoDisplay.filter(_BTID => _BTID && _BTID !== updateBTID)

  try {
    addEntry('PresenterService',newValue?'PresenterHidden': 'PresenterUnHidden',auditMessage, 'info')
    await docUpdateAndLog(uiDoc, { videoDisplay: newVideoDisplay }, 'uiDoc')
    dispatch({ type: TrackType.TOGGLE_VIDEO_TRACK_SUCCESS })
    dispatch({ type: UPDATE_UI_DOC_SUCCESS })

  }
  catch (e) {

    if (localParticipant && storage.hasPermission) storage.setItem(hiddenKey, curValue)
    dispatch({ type: TrackType.TOGGLE_VIDEO_TRACK_ERROR })
    dispatch({ type: UPDATE_UI_DOC_ERROR, payload: e })

  }

}

export const adjustParticipantVideoQuality = () => async (dispatch, getState: () => State) => {

  const state = getState()
  const dialedInParticipants = selectDialInParticipants(state)
  const presenters = [...getPresentersFromSeatingOrder(getState()).filter((participant) => !dialedInParticipants.includes(`brightTALK-dialin-${participant.id}`)), ...dialedInParticipants]
  const { room, tracks: { selectedVideoDeviceID } } = state
  const getPresenterBackground = selectPresenterBackground()
  const background = getPresenterBackground(state)
  /* Fetch the new dimensions and check to see if they're different from the current */
  const videoTracks = get(room, 'room.localParticipant.videoTracks', new Map())

  if (videoTracks.size === 0) return dispatch({ type: TrackType.VIDEO_QUALITY_CHANGE_SUCCESS })

  let response

  try {

    response = await amendVideoQuality(presenters.length, videoTracks, selectedVideoDeviceID, background.type !== VirtualBackgrounds.NONE)

  }
  catch (e) {

    return dispatch({ type: TrackType.VIDEO_QUALITY_CHANGE_ERROR })

  }

  if (response.error) {

    return dispatch({ type: TrackType.VIDEO_QUALITY_CHANGE_ERROR })

  }
  else {

    return dispatch({ type: TrackType.VIDEO_QUALITY_CHANGE_SUCCESS })

  }

}
export const setAudioSource = (audioSource: AudioSource): ReduxAction<AudioSource> => ({ type: TrackType.SET_AUDIO_SOURCE, payload: audioSource })
export const addLocalTracks = () => (dispatch, getState: () => State) => {

  const { audioSource = 'microphone' } = getState().tracks

  if (audioSource === 'microphone') dispatch(createLocalAudioTrack())
  dispatch(createLocalVideoTrack())

}

export const localParticipantMuted = () => ({ type: TrackType.LOCAL_PARTICIPANT_MUTED })
export const localParticipantUnmuted = () => ({ type: TrackType.LOCAL_PARTICIPANT_UNMUTED })


export const forceLocalMute = () => async (dispatch, getState) => {

  const { room: { room, dialedInParticipants }, ui: { forcedLocalMute } } = getState()

  let changed = false

  if (room && !forcedLocalMute) {

    dispatch({ type: TrackType.FORCE_LOCAL_MUTE })
    changed = await changeTwilioTrackState(room.localParticipant.audioTracks, TrackState.DISABLE)

  }

  if (changed || (selectIsLocalParticipantDialedIn(getState()) && !forcedLocalMute)) {

    dispatch(notifications.addNotification('Presenters mics are muted during video playback', 4000))

  }

  if (selectIsLocalParticipantDialedIn(getState()) && dialedInParticipants.length > 1) {

    dispatch(localParticipantMuted())

  }

}
export const forceLocalMuteDisable = () => async (dispatch, getState) => {

  const { room: { room }, syncUi: { mute }, ui: { forcedLocalMute }, user: { BTID } } = getState()

  let changed = false

  if (forcedLocalMute) {

    dispatch({ type: TrackType.FORCE_LOCAL_MUTE_DISABLE })

  }

  if (room && !mute.includes(BTID)) {

    changed = await changeTwilioTrackState(room.localParticipant.audioTracks, TrackState.ENABLE)

  }

  if (changed || (selectIsLocalParticipantDialedIn(getState()) && forcedLocalMute)) {

    dispatch(notifications.addNotification('Presenters mics are now unmuted', 4000))

  }

}
export const startQualityCheck = () => async (dispatch, getState) => {

  const { role } = getState().config

  if (role === CONTROLLER) return

  dispatch({ type: 'START_QUALITY_CHECK'})
  startNetworkTest().then((networkTest) => {
    // networkTest.on('progress', (bitrate) => {})

    networkTest.on('completed', (report) => {
      dispatch({ type: 'QUALITY_CHECK_NETWORK_DONE', payload: report})

    })

    networkTest.on('failed', (report) => {

      dispatch({ type: 'QUALITY_CHECK_NETWORK_FAILED'})
    })
  })

  startBandwidthTest().then((bandwidthTest) => {
    // bandwidthTest.on('bitrate', (bitrate) => {})

    /* @ts-ignore */
    bandwidthTest.on('end', (report) => {

      dispatch({ type: 'QUALITY_CHECK_BANDWIDTH_DONE', payload: report})

    })
    /* @ts-ignore */
    bandwidthTest.on('error', (error) => {
      dispatch({ type: 'QUALITY_CHECK_BANDWIDTH_FAILED'})

    })
  })

}

export default {
  adjustParticipantVideoQuality,
  createLocalAudioTrack,
  createLocalAudioTrackError,
  createLocalAudioTrackSuccess,
  createLocalVideoTrack,
  createLocalVideoTrackError,
  createLocalVideoTrackSuccess,
  localTracksAdded,
  localTracksFailed,
  publishScreen,
  removeAudioTrack,
  removeEnabledAudioTrackEntry,
  removeEnabledVideoTrackEntry,
  removeLocalAudioTrackDueToDialIn,
  removeScreenshareTrack,
  removeVideoTracks,
  setAudioSource,
  setEnabledAudioTrackEntry,
  setEnabledVideoTrackEntry,
  setInitialPresenterControlState,
  setScreenshare,
  setSelectedAudioDevice,
  setSelectedVideoDevice,
  setTrackStatus,
  disableAudioOnPlayInStart,
  enableAudioOnPlayInStop,
  toggleAudio,
  toggleVideo,
  unattachedTrack,
  unpublishScreen,
  unsetScreenshare,
  verifyEnabledAudioTracks,
  verifyEnabledVideoTracks,
  addLocalTracks,
  sendDialInMuteNotification,
  localParticipantMuted,
  localParticipantUnmuted,
  forceLocalMute,
  forceLocalMuteDisable
}
